<template>
  <section v-if="activities.length" class="ni-section ni-activities" id="activities">
    <div class="ni-container">
      <SectionHeader
        variant="dark"
        :subtitle="t('newIndex.sections.activities.subtitle')"
        more-href="/active_list"
      >
        <template #title>
          <span class="ni-section-header__title-mark">
            {{ t('newIndex.sections.activities.title') }}
          </span>
        </template>
      </SectionHeader>

      <div class="ni-activities__grid">
        <a
          v-for="item in activities"
          :key="item.id"
          :id="`activity-card-${item.id}`"
          class="ni-activities__card"
          :href="item.href"
          :title="item.title"
        >
          <img class="ni-activities__image" :src="item.thumb" :alt="item.title" />
          <div class="ni-activities__mask">
            <span class="ni-activities__title">{{ item.title }}</span>
          </div>
          <img
            v-if="item.istop"
            class="ni-activities__badge"
            src="@/assets/img/recommend.png"
            alt=""
          />
        </a>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import SectionHeader from './shared/SectionHeader.vue';

defineProps({
  activities: {
    type: Array,
    default: () => [],
  },
});

const { t } = useI18n();
</script>
